import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AccountBalanceComponent from '../components/AccountBalanceComponent';

const mapStateToProps = (state) => ({
  setting: state.setting,
  balances: state.user.userBalances || [],
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountBalanceComponent));
